/* Lady by Design: cart drawer bundle nudge + Pasformsgaranti line, homepage H1 text */
(function(){
  if (window.__lbdGlobal) return; window.__lbdGlobal = true;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var TIERS = [[2,10],[3,15],[4,20],[5,25]];
  var SHIRT = '<svg aria-hidden="true" fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="1.4" viewBox="0 0 24 24"><path d="M8 3.5 2.8 6.2l1.8 4.2 2.1-.9V20.5h8.6V9.5l2.1.9 1.8-4.2L14 3.5c-.4 1.5-1.6 2.4-3 2.4S8.4 5 8 3.5z"/><circle cx="17.5" cy="17.5" r="4.6" fill="#f8f1f2"/><path d="m15.4 17.6 1.5 1.5 2.9-3" stroke-linecap="round"/></svg>';
  function html(n){
    var cur = 0, next = null, i;
    for (i = 0; i < TIERS.length; i++) { if (n >= TIERS[i][0]) cur = TIERS[i][1]; }
    for (i = 0; i < TIERS.length; i++) { if (n < TIERS[i][0]) { next = TIERS[i]; break; } }
    var msg;
    if (!next) msg = '<strong>Du får 25% rabat</strong> – den højeste pakkerabat.';
    else { var k = next[0] - n; msg = (cur ? '<strong>Du får ' + cur + '% rabat.</strong> ' : '') + 'Tilføj ' + k + ' vare' + (k > 1 ? 'r' : '') + ' mere, og få <strong>' + next[1] + '% rabat</strong>.'; }
    var bars = TIERS.map(function(t){ return '<span class="' + (n >= t[0] ? 'on' : '') + '"></span>'; }).join('');
    return '<p class="lbd-cn__msg">' + msg + '</p><div class="lbd-cn__bar" aria-hidden="true">' + bars + '</div>'
      + '<div class="lbd-cn__steps" aria-hidden="true"><span>2 stk. 10%</span><span>3 stk. 15%</span><span>4 stk. 20%</span><span>5+ stk. 25%</span></div>'
      + '<p class="lbd-cn__fit">' + SHIRT + '<span><strong>Pasformsgaranti:</strong> ny størrelse gratis · <a href="/pages/returpolitik#pasformsgaranti">Læs mere</a></span></p>';
  }
  var count = null, timer = null;
  function render(){
    var d = document.querySelector('cart-drawer'); if (!d) return;
    var old = d.querySelector('.lbd-cn');
    var foot = d.querySelector('.drawer__footer');
    if (!foot || !count) { if (old) old.remove(); return; }
    if (old && old.parentNode !== foot) { old.remove(); old = null; }
    var box = old;
    if (!box) { box = document.createElement('div'); box.className = 'lbd-cn'; foot.insertBefore(box, foot.firstChild); }
    var h = html(count);
    if (box.getAttribute('data-n') !== String(count)) { box.innerHTML = h; box.setAttribute('data-n', String(count)); }
  }
  function refresh(){
    clearTimeout(timer);
    timer = setTimeout(function(){
      fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function(r){ return r.json(); })
        .then(function(c){ count = c.item_count; render(); }).catch(function(){});
    }, 150);
  }
  function h1(){
    var h = document.querySelector('h1');
    if (h && !h.textContent.trim() && !h.querySelector('.visually-hidden')) {
      var s = document.createElement('span'); s.className = 'visually-hidden';
      s.textContent = 'Lady by Design – damemode, vinterfrakker, strik og støvler';
      h.appendChild(s);
    }
  }
  function init(){
    h1();
    var d = document.querySelector('cart-drawer');
    if (d) {
      new MutationObserver(function(muts){
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (t.closest && t.closest('.lbd-cn')) continue;
          var added = muts[i].addedNodes;
          if (added.length === 1 && added[0].classList && added[0].classList.contains('lbd-cn')) continue;
          refresh(); return;
        }
      }).observe(d, { childList: true, subtree: true });
      refresh();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
